import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const List = lazy(() => import('./components/List'))
const Detail = lazy(() => import('./components/Detail'))
const Create = lazy(() => import('./components/Create'))
const HRList = lazy(() => import('./components/HRContacts'))

const MarketingModule: RouteObject = {
    path: 'contacts',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'humanresources',
            element: <HRList />,
        },
        {
            path: ':contactSourceID',
            element: <Detail />,
        },
        {
            path: 'new',
            element: <Create />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default MarketingModule
